"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataListRow = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var DataListRow = function (props) {
    var classes = classnames_1.default('DataList__Row', props.className);
    return react_1.default.createElement("div", { className: classes }, props.children);
};
exports.DataListRow = DataListRow;
//# sourceMappingURL=DataListRow.js.map